import React from 'react'
import { Link as ChakraLink, Accordion, Button } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import classes from './SiteMenu.module.css'
import Header from '../Header/Header'
import LinkAccordionItem from '../LinkAccordionItem/LinkAccordionItem'
import { useGlobalStore } from '../../store/globalStore'
import { useStudentsTagsModalStore } from '../../store/modalsStore'

function SiteMenu() {
    const pageAccess = useGlobalStore(state => state.pageAccess)
    const tagsModalDisclosure = useStudentsTagsModalStore(state => state.disclosure)

    return (
        <div className={classes.container}>
            <Header />
            <Accordion className={classes.menu} allowMultiple={true}>
                {
                pageAccess.adminSettings &&
                <LinkAccordionItem title="Администратор">
                    <ChakraLink as={Link} to={'/aadmin/contexts'}>Контексты</ChakraLink>
                    <ChakraLink as={Link} to={'/aadmin/mailing-statuses'}>Статусы отписок</ChakraLink>
                    <Button
                        size='sm'
                        onClick={tagsModalDisclosure?.onOpen}
                    >
                        Создать тэг
                    </Button>
                </LinkAccordionItem>
                }
                {
                pageAccess.myStudents &&
                <LinkAccordionItem title="Мои ученики">
                    {pageAccess.myStudents &&
                    <ChakraLink as={Link} to="/mystudents">Мои ученики</ChakraLink>}
                    {pageAccess.myStudentsProlongations &&
                    <ChakraLink as={Link} to="/mystudents/prolongations">Продления</ChakraLink>}
                    {/* {pageAccess.myStudents &&
                    <ChakraLink as={Link} to="/mystudents/addsales">Допродажи</ChakraLink>} */}
                    {/* {pageAccess.myStudentsTests &&
                    <ChakraLink as={Link} to="/mystudents/tests">Зачеты</ChakraLink>} */}
                </LinkAccordionItem>
                }
                {
                pageAccess.duty &&
                <LinkAccordionItem title="Дежурство">
                    {pageAccess.duty && <>
                    <ChakraLink as={Link} to="/duty">Дежурство</ChakraLink>
                    <ChakraLink as={Link} to="/">Статистика</ChakraLink>
                    </>}
                    {/* {pageAccess.dutyTestsRecording &&
                    <ChakraLink as={Link} to="/duty/tests/recording">Запись на зачеты</ChakraLink>} */}
                    {/* {pageAccess.dutyTestsConducting &&
                    <ChakraLink as={Link} to="/duty/tests/conducting">Проведение зачетов</ChakraLink>} */}
                </LinkAccordionItem>
                }
                {
                pageAccess.myEmployees &&
                <LinkAccordionItem title="Мои исполнители">
                    {pageAccess.myEmployees &&
                    <ChakraLink as={Link} to="/myemployees">Мои исполнители</ChakraLink>}
                    {/* <ChakraLink as={Link} to="/">Чат</ChakraLink> */}
                    {/* <ChakraLink as={Link} to="/">ДЗ</ChakraLink> */}
                    {/* <ChakraLink as={Link} to="/">Продления</ChakraLink> */}
                    {/* <ChakraLink as={Link} to="/">Допродажи</ChakraLink> */}
                    {/* <ChakraLink as={Link} to="/myemployees/tests">Зачеты</ChakraLink> */}
                    {/* <ChakraLink as={Link} to="/">Трекинг</ChakraLink> */}
                    {pageAccess.myEmployeesChangeRole &&
                    <ChakraLink as={Link} to="/myemployees/change-role">Смена ролей</ChakraLink>}
                </LinkAccordionItem>
                }
                {
                pageAccess.analytics &&
                <LinkAccordionItem title="Аналитика">
                    <ChakraLink as={Link} to="/analytics/prolongation-files">Выгрузки продлений</ChakraLink>
                </LinkAccordionItem>
                }
                {
                pageAccess.collectionScores &&
                <LinkAccordionItem title="Сбор баллов">
                    <ChakraLink as={Link} to="/collecting-scores">Сбор баллов</ChakraLink>
                    {pageAccess.CollectingStatistics &&
                    <ChakraLink as={Link} to="/collecting-scores/stats">Статистика</ChakraLink>}
                </LinkAccordionItem>
                }
            </Accordion>
        </div>
    )
}

export default SiteMenu
